import Spinners from "components/Shared/Spinners"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap"
import { getInterviewsScheduleList } from "store/actions/interviewsAction"

const Interviews = () => {
  const { loading, interviewsList } = useSelector(state => state.Interviews)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  console.log(interviewsList)

  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    const payload = {
      limit: 10,
      page_number: 1,
      order_by: 1,
      filters: {
        status: -1,
        city_id: 0,
        specialization_id: 0,
        gender: "",
        nationality_id: 0,
        education_qualification_id: 0,
        employee_experience: 0,
        total_capacity: 0,
        employee_experience_as_per_document: 0,
        keyword: "",
        date_range: {},
      },
    }

    dispatch(getInterviewsScheduleList(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <div className="d-flex justify-content-between mb-4 align-items-center">
                  <h4 className="card-title ">Interview Appointments</h4>
                  <div>
                    <button
                      className="main_btn"
                      onClick={() => navigate("/interview-appointments/create")}
                    >
                      Add New
                    </button>
                  </div>
                </div>
                <Card className="user_personal_info">
                  <CardBody>
                    {loading && interviewsList.length === 0 ? (
                      <p>No data found</p>
                    ) : (
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <thead className="table-light full_th">
                            <tr>
                              <th>{t("S. No.")}</th>
                              <th>{t("Title")}</th>
                              <th>{t("Description")}</th>
                              <th>{t("Total Capacity")}</th>
                              <th>{t("Total User Enrolled")}</th>
                              <th>{t("Total Available Seat")}</th>
                              {/* <th>{t("Education Qualification")}</th> */}
                              {/* <th>{t("Employee Experience")}</th> */}
                              <th>{t("Scheduled Date")}</th>
                              <th>{t("Scheduled Time")}</th>
                              {/* <th>{t("Gender")}</th> */}
                              {/* <th>{t("Nationality")}</th> */}
                              {/* <th>{t("Specialization")}</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {interviewsList?.map((item, index) => (
                              <tr
                                key={index}
                              
                              >
                                <th scope="row">{index + 1}</th>
                                <td>{item?.title}</td>
                                <td>{item?.description || "-"}</td>
                                <td>{item?.total_capacity || "-"}</td>
                                <td>{item?.total_user_enrolled}</td>
                                <td>{item?.total_available_seat}</td>
                                {/* <td>{item?.education_qualification?.name}</td> */}
                                {/* <td>{item?.employee_experience}</td> */}
                                <td>{item?.start_date}</td>
                                <td>
                                  {item?.start_time} {item?.end_time}
                                </td>
                                {/* <td>{item?.gender}</td>
                                <td>{item?.nationality?.name}</td>
                                <td>{item?.specialization?.name}</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default Interviews
